export const wishlistPerPage = 12